// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const ContractBuilderPage = lazy(() => import('./pages/ContractBuilderPage'));
const ContractEsignPage = lazy(() => import('./pages/ContractEsignPage'));
const ContractVersionsPage = lazy(() => import('./pages/ContractVersionsPage'));
const ObligationsPage = lazy(() => import('./pages/ObligationsPage'));
const RenewalAlertsPage = lazy(() => import('./pages/RenewalAlertsPage'));

export const ContractsRoutes: RouteObject = {
  path: 'contracts',
  element: <ModuleGuard moduleId="sales.contracts" />,
  children: [
    { path: 'contract-builder', element: <ContractBuilderPage />, handle: { crumb: 'Contract Builder' } },
    { path: 'contract-esign', element: <ContractEsignPage />, handle: { crumb: 'Contract Esign' } },
    { path: 'contract-versions', element: <ContractVersionsPage />, handle: { crumb: 'Contract Versions' } },
    { path: 'obligations', element: <ObligationsPage />, handle: { crumb: 'Obligations' } },
    { path: 'renewal-alerts', element: <RenewalAlertsPage />, handle: { crumb: 'Renewal Alerts' } },
  ],
};
